<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.6066 6.70785L6.70711 16.6073C6.31658 16.9979 6.31658 17.631 6.70711 18.0216C7.09763 18.4121 7.7308 18.4121 8.12132 18.0216L18.0208 8.12207C18.4113 7.73154 18.4113 7.09838 18.0208 6.70785C17.6303 6.31733 16.9971 6.31733 16.6066 6.70785Z"
      :fill="color"
    />
    <path
      opacity="0.3"
      d="M18.0207 16.6066L8.12117 6.70711C7.73064 6.31658 7.09748 6.31658 6.70696 6.70711C6.31643 7.09763 6.31643 7.7308 6.70696 8.12132L16.6065 18.0208C16.997 18.4113 17.6301 18.4113 18.0207 18.0208C18.4112 17.6303 18.4112 16.9971 18.0207 16.6066Z"
      :fill="color"
    />
  </svg>
</template>
<script setup lang="ts">
import { type CbIconProps, cbIconDefaults } from "../cb-icon.props";

withDefaults(defineProps<CbIconProps>(), cbIconDefaults);
</script>
